import * as React from 'react';
import { useEffect, useState } from 'react';
import {
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { Bar } from 'react-chartjs-2';
import Chart from 'chart.js/auto';
import { CategoryScale } from 'chart.js';
import { UsageType } from '../pages/Dashboard';
import { useSelector } from '../../store/store';
Chart.register(CategoryScale);

const defaultData = {
  labels: ['2022-07', '2022-06', '2022-05'],
  datasets: [
    {
      label: '着信件数',
      // データの値
      data: [0, 0, 0],
      // グラフの背景色
      backgroundColor: [
        'rgb(255, 99, 132, 1',
        'rgb(255, 99, 132, 0.2',
        'rgb(255, 99, 132, 0.2',
      ],
      // グラフの枠線の色
      borderColor: [
        'rgb(255, 99, 132)',
        'rgb(255, 99, 132)',
        'rgb(255, 99, 132)',
      ],
      // グラフの枠線の太さ
      borderWidth: 1,
    },
    {
      label: '録音件数',
      // データの値
      data: [0, 0, 0],
      // グラフの背景色
      backgroundColor: [
        'rgb(99, 255, 132, 1',
        'rgb(99, 255, 132, 0.2',
        'rgb(99, 255, 132, 0.2',
      ],
      // グラフの枠線の色
      borderColor: [
        'rgb(99, 255, 132)',
        'rgb(99, 255, 132)',
        'rgb(99, 255, 132)',
      ],
      // グラフの枠線の太さ
      borderWidth: 1,
    },
  ],
};

const defaultRows = [
  {
    item: '月額基本料（録音100件、応答メッセージ変更3回含む）',
    quantity: '',
    unitCost: '',
    amount: '',
  },
  {
    item: '超過録音件数（101件以上）',
    quantity: '',
    unitCost: '',
    amount: '',
  },
  {
    item: '超過応答メッセージ変更(4回以上）',
    quantity: '',
    unitCost: '',
    amount: '',
  },
  {
    item: `消費税（${process.env.REACT_APP_TAX_RATE}%）`,
    quantity: '',
    unitCost: '',
    amount: '',
  },
  {
    item: '当月ご請求額',
    quantity: '',
    unitCost: '',
    amount: '',
  },
];

interface Props {
  usage: UsageType | undefined;
}
function Usage(props: Props) {
  const { usage } = props;
  // ストアからユーザー情報を取得
  const user = useSelector((state) => state.loginUser.user);

  // const [usage, setUsage] = useState(props.usage);
  const [rows, setRows] = useState(defaultRows);
  const [data, setData] = useState<typeof defaultData>();
  useEffect(() => {
    if (usage) {
      // グラフを作成
      usage?.records.map((record, idx) => {
        defaultData.labels[idx] = record.target_month; // データラベル
        defaultData.datasets[0].data[idx] = record.incoming_count; // 着信件数
        defaultData.datasets[1].data[idx] = record.recorded_count; // 録音件数
        return true;
      });
      setData(defaultData);
      // 料金を作成
      const rows = defaultRows;
      let amount = user.price.base_charge; // 月額基本料
      rows[0].amount = user.price.base_charge.toString(); // 月額基本料
      rows[1].unitCost = user.price.ext_recording.toString(); // 録音超過単価
      rows[2].unitCost = user.price.ext_response.toString(); // メッセージ変更超過単価
      if (usage.records[0].recorded_count > 100) {
        // 録音件数が100件を超えた場合
        rows[1].quantity = (usage.records[0].recorded_count - 100).toString();
        rows[1].amount = (
          (usage.records[0].recorded_count - 100) *
          user.price.ext_recording
        ).toString();
        amount +=
          (usage.records[0].recorded_count - 100) * user.price.ext_recording;
      } else {
        // 録音件数が100件以内の場合
        rows[1].quantity = '0';
        rows[1].amount = '0';
      }
      if (usage.response_change_count > 3) {
        // 応答メッセージの変更回数が3件を超えた場合
        rows[2].quantity = (usage.response_change_count - 3).toString();
        rows[2].amount = (
          (usage.response_change_count - 3) *
          user.price.ext_response
        ).toString();
        amount += (usage.response_change_count - 3) * user.price.ext_response;
      } else {
        // 応答メッセージの変更回数が3件以内の場合
        rows[2].quantity = '0';
        rows[2].amount = '0';
      }
      rows[3].amount = Math.floor(
        (amount * process.env.REACT_APP_TAX_RATE) / 100,
      ).toString(); // 消費税
      rows[4].amount = usage.amount.toString(); // 利用料
      setRows(rows);
    }
  }, [usage, user]);

  return (
    <Stack spacing={2}>
      {data ? <Bar data={data} /> : null}
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: '100%' }} aria-label='ご利用料金'>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell align='right'>回数</TableCell>
              <TableCell align='right'>単価</TableCell>
              <TableCell align='right'>金額(円)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow
                key={row.item}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell component='th' scope='row'>
                  {row.item}
                </TableCell>
                <TableCell align='right'>{row.quantity}</TableCell>
                <TableCell align='right'>{row.unitCost}</TableCell>
                <TableCell align='right'>{row.amount}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  );
}

export default Usage;
